import { ActionTitleMenuRoot } from './ActionTitleMenuRoot';
import { ActionTitleMenuItem } from './ActionTitleMenuItem';

export const ActionTitleMenu = {
  Root: ActionTitleMenuRoot,
  Item: ActionTitleMenuItem,
};
